
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as account9I9xKOwlHbMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45accountWmJLiSRvANMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordZzerM36mQiMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homeFoNl8ED0UuMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/home.vue?macro=true";
import { default as indexnoBzcqE4OeMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/index.vue?macro=true";
import { default as login44TlQCXQM0Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/login.vue?macro=true";
import { default as notificationshFC2OrumVTMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordyHr6cFzpFqMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filterslr1qhJ6IHNMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groupsEbTLhLcKqGMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93hTxrUpJkp8Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexuXD2E9rt12Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_93OCTdvXfTIjMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clientslOODsSZCYfMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheetsVHMYpBmAkQMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as indexI2Dug6ldquMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as newTTqSpSgQGRMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as exportCPjKlAVTRfMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexlV5PjNmp2kMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newJwCju1EsMsMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93Dlm8nYPrYpMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as importtpANOWyPekMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as indexdKzpo9OTD4Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createTKQAZiByDXMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_93JPB6Ww0XZCMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_93pNnObeEkIbMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexK7RYj1VeSwMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventoriesirqx9k6Lv1Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventorywGUpKOcFr0Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexkijJbhLRWIMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activityyX76Wx8mTBMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndown4IEvXvmazLMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as indexf3tlAwR3YCMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reportinggE0O55DVp1Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_93CwrlKKIKcGMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as indexe8lNSTidsoMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointmentsZH63yf1nSLMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as index3wAtwvC5z0Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_93kJ5yoiOdZOMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignmentrRnXlprJPUMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardh7RS4LVlLxMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as indexzA7OGL9ovlMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_93PjR6RAegLiMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorsNa6bFJe5w9Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indexdFT8vfdxgxMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmapJEb21vUZjBMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexuwS3h8zX8VMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasks692x4d7JHdMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rollout6oPOfVR5JtMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointmentjRADgyfEwJMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as brandingV75SJDqEb4Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createg3W508UIdJMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_934uojij7He7Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as indexjeigC3fOzwMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklistsKMlS9jeY4YMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45linkshgvLFv1p7uMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsjWVXMg6Ah3Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as indexPCB6cs4SidMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsFk4R54RJeWMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rolloutsArtBew8sR4Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptionuhOsDw10YwMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as usersEKBZyQEwmBMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as create2oJllRyfA4Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_930xmcw29EEOMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as indexOuvJJuQiD9Meta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflowswbw2POfFsNMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settingsUQxV0ipSvbMeta } from "/codebuild/output/src1387739503/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: account9I9xKOwlHbMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45accountWmJLiSRvANMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordZzerM36mQiMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homeFoNl8ED0UuMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexnoBzcqE4OeMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login44TlQCXQM0Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationshFC2OrumVTMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordyHr6cFzpFqMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventorywGUpKOcFr0Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filterslr1qhJ6IHNMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groupsEbTLhLcKqGMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clientslOODsSZCYfMeta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93hTxrUpJkp8Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexuXD2E9rt12Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_93OCTdvXfTIjMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheetsVHMYpBmAkQMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: exportCPjKlAVTRfMeta?.name,
    path: "export",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: indexI2Dug6ldquMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: newTTqSpSgQGRMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: importtpANOWyPekMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexlV5PjNmp2kMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newJwCju1EsMsMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93Dlm8nYPrYpMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: indexdKzpo9OTD4Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventoriesirqx9k6Lv1Meta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createTKQAZiByDXMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_93JPB6Ww0XZCMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_93pNnObeEkIbMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexK7RYj1VeSwMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexkijJbhLRWIMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reportinggE0O55DVp1Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activityyX76Wx8mTBMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndown4IEvXvmazLMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: indexf3tlAwR3YCMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rollout6oPOfVR5JtMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointmentsZH63yf1nSLMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_93CwrlKKIKcGMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: indexe8lNSTidsoMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignmentrRnXlprJPUMeta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: index3wAtwvC5z0Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_93kJ5yoiOdZOMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardh7RS4LVlLxMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorsNa6bFJe5w9Meta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: indexzA7OGL9ovlMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_93PjR6RAegLiMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indexdFT8vfdxgxMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmapJEb21vUZjBMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasks692x4d7JHdMeta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexuwS3h8zX8VMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointmentjRADgyfEwJMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settingsUQxV0ipSvbMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: brandingV75SJDqEb4Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklistsKMlS9jeY4YMeta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createg3W508UIdJMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_934uojij7He7Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: indexjeigC3fOzwMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45linkshgvLFv1p7uMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsjWVXMg6Ah3Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: indexPCB6cs4SidMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrationsFk4R54RJeWMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rolloutsArtBew8sR4Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptionuhOsDw10YwMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: usersEKBZyQEwmBMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflowswbw2POfFsNMeta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: create2oJllRyfA4Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_930xmcw29EEOMeta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: indexOuvJJuQiD9Meta || {},
    component: () => import("/codebuild/output/src1387739503/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]